import { Link } from 'react-router-dom';

export default function CategoryOverview() {
  const items = [
    { name: '电影', slug: 'dianying', icon: 'ri-movie-2-line', desc: '动作·喜剧·爱情·科幻', color: 'bg-primary-500' },
    { name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-2-line', desc: '国产·韩剧·美剧·日剧', color: 'bg-accent-500' },
    { name: '纪录片', slug: 'jilupian', icon: 'ri-film-line', desc: '自然·历史·科技·人文', color: 'bg-secondary-500' },
    { name: '动漫', slug: 'dongman', icon: 'ri-emotion-line', desc: '日漫·国漫·新番·经典', color: 'bg-primary-600' },
    { name: '综艺', slug: 'zongyi', icon: 'ri-live-line', desc: '音乐·脱口秀·真人秀', color: 'bg-accent-600' },
  ];

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          按类型浏览平台
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          选择你感兴趣的影视类型，发现最合适的免费看片平台
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {items.map((item) => (
          <Link
            key={item.slug}
            to={`/category/${item.slug}`}
            className="group bg-background-50 border border-background-200/70 rounded-lg p-5 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer"
          >
            <div className={`w-12 h-12 mx-auto mb-3 rounded-full ${item.color} flex items-center justify-center`}>
              <i className={`${item.icon} text-white text-xl w-5 h-5 flex items-center justify-center`}></i>
            </div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
              {item.name}
            </h3>
            <p className="text-xs text-foreground-500">{item.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}